function equalizeTitlesPerParent() {
    const parents = document.querySelectorAll('.wls-tiers-earn');

    parents.forEach(parent => {
        const titles = parent.querySelectorAll('.wls-tiers-earn__box-title');
        let maxHeight = 0;

        titles.forEach(title => {
        title.style.height = 'auto';
        });

        titles.forEach(title => {
        const height = title.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
        });

        titles.forEach(title => {
        title.style.height = maxHeight + 'px';
        });
    });
}

window.addEventListener('load', equalizeTitlesPerParent);

window.addEventListener('resize', equalizeTitlesPerParent);